import React, { memo } from "react";
import { Image, Flex, Text, Divider } from "@chakra-ui/react";
import { motion } from "framer-motion";
import SupportCardComponent from "../card";
export default memo(function SupportItemComponent({ item }) {
   return (
      <Flex
         as={motion.div}
         whileHover={{ y: "-10px" }}
         px={"24px"}
         pt={"18px"}
         pb={"30px"}
         flex={1}
         flexDir={"column"}
         bg={"white"}
         boxShadow={"0px 20px 60px 0px rgba(0,0,0,0.04)"}
         borderRadius={"12px"}>
         {item.infolist.map((item) => {
            return (
               <Flex mt={"12px"} key={item}>
                  <Image
                     userSelect="none"
                     boxSize={"26px"}
                     p={"5px"}
                     src={process.env.REACT_APP_PUBLIC_URL + "iconfont/icon_selected.svg"}
                  />
                  <Text ml={"15px"} fontSize={"18px"} lineHeight={"26px"}>
                     {item}
                  </Text>
               </Flex>
            );
         })}
         <SupportCardComponent item={item.bots[0]} />
         <Divider mt="30px" />
         <SupportCardComponent item={item.bots[1]} />
      </Flex>
   );
});
